var map = {
	"./anti_pattern_controller.js": 37,
	"./filters_controller.js": 38,
	"./hello_controller.js": 39,
	"./inventory_bundle_controller.js": 40,
	"./load_more_controller.js": 41,
	"./medicine_controller.js": 42,
	"./medicine_show_controller.js": 43,
	"./preset_controller.js": 44,
	"./tabs_controller.js": 45
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;